<template>
    <div id="newSo">
      <a-row class="padding6">
          <a-button type="primary" size="small">Query</a-button>
          <a-button type="danger" size="small" class="ml4" @click="clearForm">Clear</a-button>
      </a-row>
        <a-row class="padding6">
            <a-form :form="form">
                <a-row type="flex" justify="start">
                    <a-col :span="4" class="ml4">
                        <a-form-item label="ASN NO" class="genericFrom">
                            <a-input
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                                   'asnNo',
                                  ]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="4" class="ml4">
                        <a-form-item label="Status" class="genericFrom">
                            <a-select
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                               'Status',
                              ]">
                                <a-select-option value="jack">Jack</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="4" class="ml4">
                        <a-form-item label="Order Type" class="genericFrom">
                            <a-select
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                                   'Status',
                                  ]">
                                <a-select-option value="jack">Jack</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="4" class="ml4">
                        <a-form-item label="SKU" class="genericFrom" >
                            <a-input-search
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                                   'SKU',
                                  ]"
                               @search="onSearch" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="4" class="ml4">
                        <a-form-item label="ref1" class="genericFrom">
                            <a-input
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                               'ref1',
                              ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="4" class="ml4">
                        <a-form-item label="Date" class="genericFrom">
                            <a-date-picker
                                size="small"
                                style="width: 100%;"
                                v-decorator="[
                               'Date',
                              ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-form-item label="CLS/CNCL" class="genericFrom">
                        <a-checkbox />
                    </a-form-item>
                </a-row>
            </a-form>
        </a-row>
        <a-row type="flex" justify="space-between">
            <a-col>
                <a-row type="flex" justify="start" align="middle">
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t('roleGe.Add') }}</span>
                        </template>
                        <img class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22" >
                    </a-tooltip>
                    <a-popconfirm
                            :title="$t('pubGicSet.AreyoudeleTask')"
                            :okText="$t('pubGicSet.Yes')"
                            :cancelText="$t('pubGicSet.No')"
                    >
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('roleGe.Delete') }}</span>
                            </template>
                            <img class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                        </a-tooltip>
                    </a-popconfirm>
                    <a-dropdown >
                        <a class="ant-dropdown-link" href="#">
                            <img class="sbxs mllr4" src="../../../assets/img/more.png"  width="22" height="22">
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item style="font-size: 12px" >

                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </a-row>
            </a-col>
            <a-col>
                <a-pagination
                        :pageSizeOptions="page.pageSizeOptions"
                        :showTotal="total => `Total of ${page.pagingTotal}  Records`"
                        size="small"
                        :total="page.pagingTotal"
                        v-model="page.currentVal"
                        :pageSize.sync="page.pagingSize"
                        @change="tableChangePage"
                        @showSizeChange="onShowSizeChange"
                        showSizeChanger
                />
            </a-col>
        </a-row>
        <a-row class="mt4">
            <vxe-table
                    stripe
                    resizable
                    border
                    show-header-overflow
                    show-overflow
                    highlight-hover-row
                    height="580"
                    size="mini"
                    @cell-dblclick="dbClickEdit"
                    :edit-config="{trigger: 'dblclick', mode: 'cell'}"
                    ref="shipmentOrderTable"
                    :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;"></span>
                </template>
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <vxe-table-column sortable field="driver" title="Rec ID"></vxe-table-column>
                <vxe-table-column sortable field="status" title="Status"></vxe-table-column>
                <vxe-table-column sortable field="numberOfWaypoint" title="No"></vxe-table-column>
                <vxe-table-column sortable field="orderType" title="Order Type"></vxe-table-column>
                <vxe-table-column sortable field="routeId" title="RefNum" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                <vxe-table-column sortable field="uid" title="RefNum"></vxe-table-column>
                <vxe-table-column sortable field="RefNum2" title="RefNum"></vxe-table-column>
                <vxe-table-column sortable field="RefNum3" title="RefNum"></vxe-table-column>
                <vxe-table-column sortable field="Creator" title="Creator"></vxe-table-column>
                <vxe-table-column sortable field="CreateTime" title="Create Time"></vxe-table-column>
            </vxe-table>
        </a-row>
        <a-drawer
            title="SO"
            :mask="false"
            :width="drawerWidth"
            :visible="visible"
            @close="onClose"
        >
            <template slot="footer">
                <a-button type="primary" size="small">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="form">
                <a-row>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="doId" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="status" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="No" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="orderType" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="RefNum" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="RefNum1" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="RefNum2" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="RefNum3" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Creator" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="CreateTime" class="genericFrom">
                            <a-input size="small" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-drawer>
        <a-modal
            title="SKU"
            :visible="querySearch.visible"
            width="60%"
            :maskClosable="false"
            :footer="null"
             @cancel="cancelQuerySearch">
            <a-row>
                <a-row type="flex" justify="space-between">
                    <a-col>
                        <a-row type="flex" justify="start">
                            <a-col >
                                <a-input size="small" style="width: 180px" v-model="ceshisku"/>
                            </a-col>
                            <a-col class="ml4">
                                <a-button type="primary" size="small">Query</a-button>
                            </a-col>
                            <a-col class="ml4">
                                <a-button type="danger" size="small">Reset</a-button>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col>
                        <a-pagination
                                :pageSizeOptions="page.pageSizeOptions"
                                :showTotal="total => `Total of ${page.pagingTotal}  Records`"
                                size="small"
                                :total="page.pagingTotal"
                                v-model="page.currentVal"
                                :pageSize.sync="page.pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger
                        />
                    </a-col>
                </a-row>
                <a-row style="height: 65vh;" class="mt">
                    <vxe-table
                            stripe
                            resizable
                            border
                            show-header-overflow
                            show-overflow
                            highlight-hover-row
                            height="auto"
                            size="mini"
                            :scroll-x="{enabled: false}"
                            :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;"></span>
                        </template>
                        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                        <vxe-table-column sortable field="driver" title="Rec ID"></vxe-table-column>
                        <vxe-table-column sortable field="status" title="Status"></vxe-table-column>
                        <vxe-table-column sortable field="numberOfWaypoint" title="No"></vxe-table-column>
                        <vxe-table-column sortable field="orderType" title="Order Type"></vxe-table-column>
                        <vxe-table-column sortable field="routeId" title="RefNum" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                        <vxe-table-column sortable field="uid" title="RefNum"></vxe-table-column>
                        <vxe-table-column sortable field="RefNum2" title="RefNum"></vxe-table-column>
                        <vxe-table-column sortable field="RefNum3" title="RefNum"></vxe-table-column>
                        <vxe-table-column sortable field="Creator" title="Creator"></vxe-table-column>
                        <vxe-table-column sortable field="CreateTime" title="Create Time"></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import Sortable from "sortablejs";
    export default{
        data(){
            return{
                ceshisku: null,
                querySearch: {
                   visible: false,
                },
                form:this.$form.createForm(this),
                tableData:[],
                visible: false,

                drawerWidth: 300,
                page:{
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal:0,
                    currentVal: 1,
                    pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                }
            }
        },
        created(){
            this.init()
            this.rowDrop()
        },
        beforeDestroy () {
            if (this.sortable) {
                this.sortable.destroy()
            }
        },
        methods:{
            clearForm(){
                this.form.resetFields();;
            },
            cleardata(){
                this.init()
                this.form.resetFields();
            },
            //            拖拽
            rowDrop () {
                let that = this
                this.$nextTick(() => {
                    let shipmentOrderTable = this.$refs.shipmentOrderTable
                    this.sortable = Sortable.create(shipmentOrderTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {})
                    this.sortable = Sortable.create(shipmentOrderTable.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
                        handle: '.vxe-header--column:not(.col--fixed)',
                        onEnd: ({ item, newIndex, oldIndex }) => {
                            const { fullColumn, tableColumn } = shipmentOrderTable.getTableColumn()
                            const targetThElem = item
                            const wrapperElem = targetThElem.parentNode
                            const newColumn = fullColumn[newIndex]
                            if (newColumn.fixed) {
                                // 错误的移动
                                if (newIndex > oldIndex) {
                                    wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex])
                                } else {
                                    wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem)
                                }
                                return this.$XModal.message({ message: '固定列不允许拖动！', status: 'error' })
                            }
                            // 转换真实索引
                            const oldColumnIndex = shipmentOrderTable.getColumnIndex(tableColumn[oldIndex])
                            const newColumnIndex = shipmentOrderTable.getColumnIndex(tableColumn[newIndex])
                            // 移动到目标列
                            const currRow = fullColumn.splice(oldColumnIndex, 1)[0]
                            fullColumn.splice(newColumnIndex, 0, currRow)
                            shipmentOrderTable.loadColumn(fullColumn)
                        }
                    })

                })
            },
            cancelQuerySearch(){
                this.querySearch.visible = false
            },
            onSearch(){
                this.querySearch.visible = true
                this.ceshisku = this.form.getFieldValue('SKU')
            },
            init(type){
                let params = {
                    pageNumber:this.page.currentVal,
                    pageSize: this.page.pagingSize,
                }
                params.from = '2019-12-15'
                params.to = '2020-12-29'
                ajax.get(api.TMSGETROUTES,params).then(res=>{
                    this.tableData = res.data
                    this.page.pagingTotal = res.total
                })
            },
            onClose(){
                this.visible = false
            },
            dbClickEdit({row}){
                this.drawerWidth = document.documentElement.clientWidth / 1.5
                this.visible = true
            },
            tableChangePage(){

            },
            onShowSizeChange(){

            }
        }
    }
</script>
<style>
    #newSo{
        background: #fff;
    }
</style>